import AdvisorMapDetails from "../../../components/DataCollection/Advisor/AdvisorMapDetails/AdvisorMapDetails";

export const AdvisorMapDetailsScreen = () => {
  return (
    <div>
      <AdvisorMapDetails />
    </div>
  );
};
